import React, { useContext, useEffect, useState } from "react";
import { Navbar } from "../../components/Navbar/Navbar";
import { Activity } from "./Activity";
import Pagination from "../../components/Pagination/Pagination";
import AuthContext from "../../context/AuthProvider";
import {
  getWalletActivity,
  getWalletBalance,
  getSterlingWallet,
} from "../../store/actions/walletActions";
import { useDispatch, useSelector } from "react-redux";
import { setActiveView } from "../../store/slices/walletActivitySlice";
import { ErrorView } from "../Helpers/errorView";
import { WalletModal } from "./TopUpModal/WalletModal";
import { SterlingWalletCard } from "./SterlingWallet/SterlingWalletCard";
import { SterlingHistoryTab } from "./SterlingWallet/SterlingHistoryTab";
import {
  WalletPage,
  WalletHeader,
  WalletHeaderBadge,
  BalanceCard,
  WalletTabContainer,
} from "./style";

// Tab identifiers
const TAB_TRANSACTIONS = "transactions";
const TAB_STERLING     = "sterling";
const TAB_ACTIVITY     = "activity";

export const Wallet = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [walletTab, setWalletTab] = useState(TAB_TRANSACTIONS);
  const [sterlingRefreshKey, setSterlingRefreshKey] = useState(0);
  const { user } = useContext(AuthContext);
  const { activeView, balance, activity } = useSelector(
    (state) => state.wallet
  );
  const dispatch = useDispatch();
  const pageSize = 10;
  const isSterlingWalletEnabled = !!user?.sterling_wallet_enabled;
  const bankName = user?.accountName;

  useEffect(() => {
    dispatch(getWalletBalance(user));
    if (window.drift.api) {
      window.drift.api.widget.show();
    }
    return () => {
      if (window.drift.api) {
        window.drift.api.widget.hide();
      }
    };
  }, []);

  const handlePageChange = (page) => setCurrentPage(page);
  const handleGotoFirstPage = () => setCurrentPage(1);
  const handleGotoLastPage = (page) => setCurrentPage(page);

  const handleRefreshPage = () => {
    dispatch(getWalletActivity({ user, pageSize, currentPage, activeView }));
    dispatch(getWalletBalance(user));
    if (isSterlingWalletEnabled) {
      dispatch(getSterlingWallet(user));
      setSterlingRefreshKey((k) => k + 1);
    }
  };

  // Legacy credit/debit toggle (used inside the Transactions tab)
  const handleCreditDebitToggle = () => {
    if (activeView === "Credit") dispatch(setActiveView("Debit"));
    if (activeView === "Debit") dispatch(setActiveView("Credit"));
    setCurrentPage(1);
  };

  useEffect(() => {
    if (walletTab === TAB_TRANSACTIONS || walletTab === TAB_ACTIVITY) {
      dispatch(getWalletActivity({ user, pageSize, currentPage, activeView }));
    }
  }, [currentPage, activeView, pageSize, user, walletTab]);

  return (
    <>
      <Navbar />
      <WalletPage className="col-md-10 offset-md-1">
        <WalletHeader>
          <h6>Wallet</h6>
          <WalletHeaderBadge>200 Naira = 200 units</WalletHeaderBadge>
        </WalletHeader>

        <BalanceCard>
          <div className="flexy flexyM">
            <div style={{ flexGrow: 1 }}>
              <h6>Unit balance</h6>
              <h1>฿ {balance}</h1>
            </div>
            <div>
              <WalletModal reset={handleRefreshPage} />
            </div>
          </div>
        </BalanceCard>

        {isSterlingWalletEnabled && (
          <SterlingWalletCard onTransferComplete={handleRefreshPage} />
        )}

        <WalletTabContainer className="analysis-tab">
          <div className="tabs">
            <button
              className={`tab ${walletTab === TAB_TRANSACTIONS ? "active2" : ""}`}
              onClick={() => {
                setWalletTab(TAB_TRANSACTIONS);
                if (activeView !== "Credit") dispatch(setActiveView("Credit"));
                setCurrentPage(1);
              }}
            >
              Transactions
            </button>

            {isSterlingWalletEnabled && (
              <button
                className={`tab ${walletTab === TAB_STERLING ? "active2" : ""}`}
                onClick={() => setWalletTab(TAB_STERLING)}
                style={{ marginLeft: "20px" }}
              >
                {bankName} History
              </button>
            )}

            <button
              className={`tab ${walletTab === TAB_ACTIVITY ? "active2" : ""}`}
              onClick={() => {
                setWalletTab(TAB_ACTIVITY);
                if (activeView !== "Debit") dispatch(setActiveView("Debit"));
                setCurrentPage(1);
              }}
              style={{ marginLeft: "20px" }}
            >
              Activity
            </button>
          </div>

          <div className="panels" style={{ position: "relative" }}>
            {/* Transactions & Activity panels (share the same activity data) */}
            {(walletTab === TAB_TRANSACTIONS || walletTab === TAB_ACTIVITY) && (
              <>
                <div className="panel active2">
                  <div className="row">
                    {activity?.data?.map((data, index) => (
                      <Activity key={index} data={data} active={activeView} />
                    ))}
                  </div>
                </div>
                {activity.data && (
                  <Pagination
                    itemsCount={activity?.pagination?.totalItems}
                    pageSize={pageSize}
                    onPageChange={handlePageChange}
                    onGotoLastPage={handleGotoLastPage}
                    onGotoFirstPage={handleGotoFirstPage}
                    currentPage={currentPage}
                  />
                )}
                {(!activity.data || !activity.data.length) && <ErrorView />}
              </>
            )}

            {/* Sterling History panel */}
            {walletTab === TAB_STERLING && <SterlingHistoryTab key={sterlingRefreshKey} />}
          </div>
        </WalletTabContainer>
      </WalletPage>
    </>
  );
};
